import React, { useEffect, useRef, useState, useCallback, memo } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FaEllipsisV } from "react-icons/fa";
import { deleteProposal } from "../../services/proposalService";
import Swal from "sweetalert2";
import { getErrorMessage } from "../../services/errorHelper";
import "./Proposal.css";
import apiClient, { getCurrentUserId } from "../../services/apiClient";


// COMPONENTS

function Proposals() {
  const [proposals, setProposals] = useState([]);
  const [selectedEmail, setSelectedEmail] = useState(null);
  const [menuVisible, setMenuVisible] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchProposals = async () => {
      try {
        const response = await apiClient.post('/proposal_list', { user_id: getCurrentUserId() });
        setProposals(response.data);
      } catch (error) {
        console.error("Error fetching proposals:", error);
      }
    };
    fetchProposals();
  }, []);

  const handleEdit = useCallback((emailId) => {
    navigate(`/edit-proposals/${emailId}`);
  }, [navigate]);

  const handleDelete = async (proposalId) => {
    try {
      const result = await Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
          customClass: {
        popup: 'swal-top-zindex'
      }
      });

      if (result.isConfirmed) {
        await deleteProposal(proposalId);
        setProposals(proposals.filter((proposal) => proposal.id !== proposalId));
        Swal.fire("Deleted!", "Proposal has been deleted.", "success");
        //handleProductContentChange("Untitled Item");
      }
    } catch (error) {
      console.error(`Failed to delete Proposal with ID ${proposalId}:`, error);
      Swal.fire("Error", getErrorMessage(error, "Failed to delete Proposal."), "error");
    }
  };
  const toggleMenu = (email) => {
    setSelectedEmail(email);
    setMenuVisible(!menuVisible);
  };

  // The return statement contains the JSX code which is rendered and displayed on the page
  return (
    //  ================= *****  TEMPLATES BODY JSX ***** =================
    <div className='container-fluid p-lg-5 p-md-5 p-3'>
      <div className='row g-lg-5 g-md-5 g-3'>
        <div className='col-sm-12 col-md-12 col-xl-12'>
          {/* Product Templates Description about this page */}
          <div className='mb-4'>
            <h3 className='mb-1'>Proposal Templates</h3>
            <p>
              This isn’t your average “proposal”… instead, collect payments and
              e-signatures through this all-in-one booking document by combining
              an invoice (a set of services, prices, and a payment schedule)
              with the associated Contract.
            </p>
          </div>
        </div>
        {/* ========= Create a New Product Button ========= */}
        <div className='col-sm-12 col-md-6 col-xl-4 product-items'>
          <div className='h-100 bg-white rounded p-3 shadow-sm'>
            <Link
              to='/create-proposals'
              id=''
              className='h-100 d-flex align-items-center justify-content-center px-2 py-5 p-urls'
              style={{ border: "1px dashed #534dbb" }}>
              <div className='mb-4 text-center'>
                <i
                  className='fa-solid fa-plus'
                  style={{ fontSize: "70px" }}></i>
                <h6 className='mb-0 fw-bold text-uppercase'>
                  CREATE A NEW PROPOSAL
                </h6>
              </div>
            </Link>
          </div>
        </div>

        {/* ========= Basic Photo Booth Contract Button ========= */}
        {proposals.map((proposal) => (
          <div key={proposal.id} id='' className='col-sm-12 col-md-6 col-xl-4 contact-items'>
            <div className='h-100 bg-white d-flex align-items-center justify-content-center rounded p-4 shadow-sm position-relative product-items2' onClick={() => handleEdit(proposal.id)}>
              <div className='three-dot-btn'>
                <div className='position-absolute top-0 end-0 me-3 mt-2'>
                  <button className='border-0 bg-transparent ' type='button'>
                    <div id='p-dot' style={{ position: "relative", zIndex: 10000 }} onMouseEnter={() => toggleMenu(proposal)}
  onMouseLeave={() => toggleMenu(null)}>
                      <FaEllipsisV
                        
                        style={{ cursor: "pointer" }}
                      />
                      {menuVisible && selectedEmail === proposal && (
                        <div
                          className='position-absolute bg-white shadow-sm rounded'
                          style={{
                            top: "20px",
                            right: "0",
                            zIndex: "10",
                          }}>
                          <button
                            className='dropdown-item'
                            onClick={() => handleEdit(proposal.id)}>
                            Edit
                          </button>
                          <button
                            className='dropdown-item'
                            onClick={(e) => {
                              e.stopPropagation();
                              handleDelete(proposal.id)
                            }
                            }>
                            Delete
                          </button>
                        </div>
                      )}
                    </div>
                  </button>
                </div>
                <div className='text-center edit-btn'>
                  <button className='border-0 bg-transparent' type='button'>
                    <i className='fa-solid fa-file-signature'></i>
                  </button>
                  <p className='basic-photo'>
                    {proposal.title.toUpperCase()}
                  </p>
                </div>
              </div>
            </div>
          </div>
        ))}
        {/* ========= Product Template - END ========= */}
      </div>
    </div>

    // ================= *****  TEMPLATES BODY JSX ***** =================
  );
}

const MemoizedProposals = memo(Proposals);
export { MemoizedProposals as Proposals };
